import React from 'react';
import Login from './Login';
import SideMenu from './Menu';
import Description from './Description';
import VisualContent from './VisualContent';
import jsonData from '../Content.json';
import 'react-sticky-header/styles.css';
import StickyHeader from 'react-sticky-header';

export default class TenWaysToWow extends React.Component {
  state = {
    currentPage: 0,
    currentAudioFilename: "wow_audio_0.mp3",
    contentArray: jsonData["content"]
  };
  handleSetCurrentPage = (newPage) => {
    this.setState({
        currentAudioFilename: this.state.contentArray[newPage].audio,
        currentPage: newPage
    });
  }
  nextPage = () => {
    const nextPageIndex = this.state.currentPage + 1
    if( nextPageIndex < this.state.contentArray.length ) {
        this.setState({ currentPage: nextPageIndex });
    }
  }
  previousPage = () => {
      const previousPageIndex = this.state.currentPage - 1
      if( previousPageIndex >= 0 ) {
          this.setState({ currentPage: previousPageIndex });
      }
  }
  render() {
    return (
      <div className="content-page">
        <StickyHeader
            header={
              <div className="sticky-header">
                  <div className="table-row">
                      <SideMenu
                        handleSetCurrentPage={this.handleSetCurrentPage}
                        titles={this.state.contentArray.map((wayToWow, index) => (
                          wayToWow.title
                        ))}
                      />
                      <div className="navigation_butttons" background="blue">
                          <a onClick={this.previousPage}>
                            <img src="./ui-graphics/back.png" />
                          </a>
                          <a onClick={this.nextPage}>
                            <img src="./ui-graphics/next.png" />
                          </a>
                      </div>
                  </div>
              </div>
            }
          />
          <div className="content-container">
            <main className="content-container__main">
              <div className="content-container__main-vertical-container">
                  <figure>
                      <img src="./ui-graphics/header-image.png" alt="Wow" />
                  </figure>
                <div className="content-container__main-horizontal-container">
                  <div className="content-container__main-horizontal-container-child-description">
                    <Description
                      title={this.state.contentArray[this.state.currentPage].title}
                      description={this.state.contentArray[this.state.currentPage].description}
                    />
                  </div>
                  <div className="content-container__main-horizontal-container-child-visual-content">
                    <VisualContent
                      video={this.state.contentArray[this.state.currentPage].video}
                      image={this.state.contentArray[this.state.currentPage].image}
                      footerOne={this.state.contentArray[this.state.currentPage].footerOne}
                      footerTwo={this.state.contentArray[this.state.currentPage].footerTwo}
                    />
                  </div>
                </div>
              </div>
            </main>
            <footer className="content-container__footer">
              <figure>
                  <a href="https://www.avfx.com/">
                      <img src="./ui-graphics/avfx.png" alt="Wow" />
                  </a>
              </figure>
            </footer>
        </div>
      </div>
    );
  };
}



// WEBPACK FOOTER //
// ./src/components/TenWaysToWow.js